import * as React from "react";
import PropTypes from "prop-types";
import TAppPage from "../../APP/TAppPage";
import ErrorBoundaryPage from "../../common/ErrorBoundaryPage";
import * as HLConst from "../NonVisual/HLConst";
import HLHomePageForm from "../Forms/HLHomePageForm";
import HLStep1Form from "../Forms/HLStep1Form";
import HLStep2Form from "../Forms/HLStep2Form";
import HLStep3Form from "../Forms/HLStep3Form";
import HLStep4Form from "../Forms/HLStep4Form";
import HLStep5Form from "../Forms/HLStep5Form";
import HLStep6Form from "../Forms/HLStep6Form";
import HLStep7Form from "../Forms/HLStep7Form";
import HLResultSlideDrawer from "../Drawers/HLResultSlideDrawer";
import HLIntroForm from "../Forms/HLIntroForm";
import HLStepByStepForm from "../Forms/HLStepByStepForm";
import HLFAQsHelpForm from "../Forms/HLFAQsHelpForm";
import HLWelcomeForm from "../Forms/HLWelcomeForm";

class HLAppContent extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        appState: PropTypes.object,
        onStateChange: PropTypes.func,

        onDrawerChange: PropTypes.func,
        onPageChange: PropTypes.func,
        onProjChange: PropTypes.func,
        onPackTableChange: PropTypes.func,

        left: PropTypes.number,
        appBarHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

        onCountryChange: PropTypes.func,
        onFirstYearPopChange: PropTypes.func,
        onHIV_PrevChange: PropTypes.func,
        onIncludeIntervAreaChange: PropTypes.func,
        onIntervAreaScaleUpChange: PropTypes.func,
        onMalariaEndemicChange: PropTypes.func,
        onMortProfileChange: PropTypes.func,
        onRankedIntervMstIDArrayChange: PropTypes.func,
        onRecalcChange: PropTypes.func,
        onRegionChange: PropTypes.func,
        onResultWkbkFileURLChange: PropTypes.func,
        onShowChildrenIntervChange: PropTypes.func,
        onShowMaternalIntervChange: PropTypes.func,
        onSideBarArrowClick: PropTypes.func,
        onStuntingIndChange: PropTypes.func,
        onWastingIndChange: PropTypes.func,
    };

    static defaultProps = {
        appState: {},
        onStateChange: () => console.log("onStateChange"),

        getDataVisChart: () => console.log("getDataVisChart"),
        onDrawerChange: () => console.log("onDrawerChange"),
        onPageChange: () => console.log("onPageChange"),
        onProjChange: () => console.log("onProjChange"),
        onPackTableChange: () => console.log("Content onPackTableChange"),

        left: 0,
        appBarHeight: 64,

        onCountryChange: () => console.log("onCountryChange"),
        onFirstYearPopChange: () => console.log("onFirstYearPopChange"),
        onHIV_PrevChange: () => console.log("onHIV_PrevChange"),
        onIncludeIntervAreaChange: () => console.log("onIncludeIntervAreaChange"),
        onIntervAreaScaleUpChange: () => console.log("onIntervAreaScaleUpChange"),
        onMalariaEndemicChange: () => console.log("onMalariaEndemicChange"),
        onMortProfileChange: () => console.log("onMortProfileChange"),
        onRankedIntervMstIDArrayChange: () => console.log("onRankedIntervMstIDArrayChange"),
        onRecalcChange: () => console.log("onRecalcChange"),
        onRegionChange: () => console.log("onRegionChange"),
        onResultWkbkFileURLChange: () => console.log("onResultWkbkFileURLChange"),
        onShowChildrenIntervChange: () => console.log("onShowChildrenIntervChange"),
        onShowMaternalIntervChange: () => console.log("onShowMaternalIntervChange"),
        onSideBarArrowClick: () => console.log("onSideBarArrowClick"),
        onStuntingIndChange: () => console.log("onStuntingIndChange"),
        onWastingIndChange: () => console.log("onWastingIndChange"),
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    renderPage = () => {
        /* props */

        const props = this.props;

        const onDrawerChange = props.onDrawerChange;
        const onPageChange = props.onPageChange;
        const onSideBarArrowClick = props.onSideBarArrowClick;
        const onCountryChange = props.onCountryChange;
        const onFirstYearPopChange = props.onFirstYearPopChange;
        const onHIV_PrevChange = props.onHIV_PrevChange;
        const onIncludeIntervAreaChange = props.onIncludeIntervAreaChange;
        const onIntervAreaScaleUpChange = props.onIntervAreaScaleUpChange;
        const onMalariaEndemicChange = props.onMalariaEndemicChange;
        const onMortProfileChange = props.onMortProfileChange;
        const onRegionChange = props.onRegionChange;
        const onShowChildrenIntervChange = props.onShowChildrenIntervChange;
        const onShowMaternalIntervChange = props.onShowMaternalIntervChange;
        const onStuntingIndChange = props.onStuntingIndChange;
        const onWastingIndChange = props.onWastingIndChange;
        const onRankedIntervMstIDArrayChange = props.onRankedIntervMstIDArrayChange;
        const onResultWkbkFileURLChange = props.onResultWkbkFileURLChange;
        const onRecalcChange = props.onRecalcChange;
        const left = this.props.left;

        /* appState */

        const appState = props.appState;

        const sideBarOpen = appState.sideBarOpen;
        const pageID = appState.pageID;
        const drawerID = appState.drawerID;
        const drawerOpen = appState.drawerOpen;
        const wideModeBool = appState.wideModeBool;
        const countryCodeInt = appState.countryCodeInt;
        const countryObjList = appState.countryObjList;
        const firstYearPop2DIntArray = appState.firstYearPop2DIntArray;
        const HIV_PrevCurrID = appState.HIV_PrevCurrID;
        const intervAreaObjList = appState.intervAreaObjList;
        const intervObjList = appState.intervObjList;
        const malariaEndemicBool = appState.malariaEndemicBool;
        const mortProfileCurrID = appState.mortProfileCurrID;
        const recalcBool = appState.recalcBool;
        const regionCurrID = appState.regionCurrID;
        const showChildrenIntervBool = appState.showChildrenIntervBool;
        const showMaternalIntervBool = appState.showMaternalIntervBool;
        const stuntingIndCurrID = appState.stuntingIndCurrID;
        const wastingIndCurrID = appState.wastingIndCurrID;
        const rankedIntervMstID2DObjArray = appState.rankedIntervMstID2DObjArray;
        const resultWkbkFileURLString = appState.resultWkbkFileURLString;
        const screenSize = appState.screenSize;

        const styles = {
            appPage: {
                left: left,
            },
        };

        let page;
        let divStyle = {};

        switch (pageID) {
            case HLConst.homePageForm:
                page = (
                    <HLHomePageForm
                        onDrawerChange={onDrawerChange}
                        pageID={pageID}
                        onPageChange={onPageChange}
                        sideBarOpen={sideBarOpen}
                        onSideBarArrowClick={onSideBarArrowClick}
                        wideModeBool={wideModeBool}
                    />
                );
                break;

            case HLConst.welcomeForm:
                page = <HLWelcomeForm onPageChange={onPageChange} />;
                break;

            case HLConst.introForm:
                page = (
                    <HLIntroForm
                        left={left}
                        onPageChange={onPageChange}
                        sideBarOpen={sideBarOpen}
                        screenSize={screenSize}
                    />
                );
                break;

            case HLConst.stepByStepForm:
                page = (
                    <HLStepByStepForm
                        intervAreaObjList={intervAreaObjList}
                        intervObjList={intervObjList}
                        onPageChange={onPageChange}
                    />
                );
                break;

            case HLConst.step1Form:
                page = (
                    <HLStep1Form
                        intervAreaObjList={intervAreaObjList}
                        intervObjList={intervObjList}
                        onPageChange={onPageChange}
                    />
                );
                break;

            case HLConst.step2Form:
                page = (
                    <HLStep2Form
                        countryCodeInt={countryCodeInt}
                        onCountryChange={onCountryChange}
                        countryObjList={countryObjList}
                        onDrawerChange={onDrawerChange}
                        firstYearPop2DIntArray={firstYearPop2DIntArray}
                        onFirstYearPopChange={onFirstYearPopChange}
                        HIV_PrevCurrID={HIV_PrevCurrID}
                        onHIV_PrevChange={onHIV_PrevChange}
                        intervAreaObjList={intervAreaObjList}
                        onIncludeIntervAreaChange={onIncludeIntervAreaChange}
                        onIntervAreaScaleUpChange={onIntervAreaScaleUpChange}
                        intervObjList={intervObjList}
                        malariaEndemicBool={malariaEndemicBool}
                        onMalariaEndemicChange={onMalariaEndemicChange}
                        mortProfileCurrID={mortProfileCurrID}
                        onMortProfileChange={onMortProfileChange}
                        onPageChange={onPageChange}
                        onRankedIntervMstIDArrayChange={onRankedIntervMstIDArrayChange}
                        onResultWkbkFileURLChange={onResultWkbkFileURLChange}
                        recalcBool={recalcBool}
                        onRecalcChange={onRecalcChange}
                        regionCurrID={regionCurrID}
                        onRegionChange={onRegionChange}
                        stuntingIndCurrID={stuntingIndCurrID}
                        onStuntingIndChange={onStuntingIndChange}
                        wastingIndCurrID={wastingIndCurrID}
                        onWastingIndChange={onWastingIndChange}
                    />
                );
                break;

            case HLConst.step3Form:
                page = <HLStep3Form onPageChange={onPageChange} />;
                break;

            case HLConst.step4Form:
                page = <HLStep4Form onPageChange={onPageChange} />;
                break;

            case HLConst.step5Form:
                page = <HLStep5Form onPageChange={onPageChange} />;
                break;

            case HLConst.step6Form:
                page = <HLStep6Form onPageChange={onPageChange} />;
                break;

            case HLConst.step7Form:
                page = <HLStep7Form onPageChange={onPageChange} />;
                break;

            case HLConst.FAQsHelpForm:
                page = <HLFAQsHelpForm onPageChange={onPageChange} />;
                break;

            // case HLConst.portalForm :
            //     page =
            //         <HLPortalForm
            //             onPageChange = {onPageChange}
            //         />;
            //
            //     divStyle = {
            //         backgroundColor : Theme.lightGrayColor,
            //         height          : "100%",
            //         width           : "100%",
            //     };
            //
            //     break;

            default:
                page = (
                    <TAppPage style={styles.appPage}>I DON'T EXIST YET! MY PAGE ID IS "{this.props.pageID}"</TAppPage>
                );
                break;
        }

        let filterSlideDrawer = null;

        if (drawerOpen) {
            switch (drawerID) {
                case HLConst.resultsDrawer:
                    filterSlideDrawer = (
                        <HLResultSlideDrawer
                            onDrawerChange={onDrawerChange}
                            intervAreaObjList={intervAreaObjList}
                            intervObjList={intervObjList}
                            rankedIntervMstID2DObjArray={rankedIntervMstID2DObjArray}
                            resultWkbkFileURLString={resultWkbkFileURLString}
                            showChildrenIntervBool={showChildrenIntervBool}
                            onShowChildrenIntervChange={onShowChildrenIntervChange}
                            showMaternalIntervBool={showMaternalIntervBool}
                            onShowMaternalIntervChange={onShowMaternalIntervChange}
                        />
                    );
                    break;

                default:
                    return null;
            }
        }

        return (
            <div style={divStyle}>
                <ErrorBoundaryPage key={pageID}>
                    <TAppPage key={pageID} style={styles.appPage}>
                        {page}
                        {filterSlideDrawer}
                    </TAppPage>
                </ErrorBoundaryPage>
            </div>
        );
    };

    render() {
        const page = this.renderPage();

        return page;
    }
}

export default HLAppContent;
